import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { BudgetForm } from "./BudgetForm";
import { SpendSection } from "./SpendSection";

export default function BudgetTab() {
  const [settings, setSettings] = useState(null);
  const [reload, setReload] = useState(0);
  useEffect(() => { api.get("/admin/llm/settings").then((r) => setSettings(r.data)).catch((e) => toast.error(apiErr(e, "Gagal memuat pengaturan"))); }, []);
  return (
    <div className="space-y-5" data-testid="llm-budget">
      {settings ? <BudgetForm settings={settings} onSaved={(s) => { setSettings(s); setReload((n) => n + 1); }} /> : <Loader2 className="animate-spin text-slate-400" />}
      <SpendSection reloadKey={reload} />
    </div>
  );
}
